module.exports = __webpack_public_path__ + "img/white_and_gold.664ec90.svg";